import {StackItemMarker} from './stack-item-marker';
import {SimplexLineupInterface} from 'interfaces/simplex-lineup-interface';
import {extractEntityIdFromSimplexItem} from 'helpers/simplex-helper';
import Const from 'const';

interface Dependencies {
    readonly simplexLineup: SimplexLineupInterface;
}

class StackAnalyzer {
    private stackItemIds: string[] = [];
    readonly simplexLineup: SimplexLineupInterface;

    constructor(dependencies: Dependencies) {
        const {simplexLineup} = dependencies;
        this.simplexLineup = simplexLineup;

        this.findStackItemIds();
    }

    public getStackItemIds(): string[] {
        return [...this.stackItemIds];
    }

    private findStackItemIds(): void {
        const simplexUnitIds = this.simplexLineup.getRaw(Const.LP_KEY_UNIT_PREFIX);
        const keyUnitIds = StackItemMarker.pickMarkedBySuffix(simplexUnitIds);
        keyUnitIds.map((simplexUnitId) => {
            this.stackItemIds.push(extractEntityIdFromSimplexItem(simplexUnitId));
        });
    }
}

export {StackAnalyzer};
